import Vue from 'vue'
import App from './App.vue'
import Meta from 'vue-meta'
Vue.use(Meta)
import { createRouter } from './router/router'
import { createStore } from './store/store'
import serverUrl from '@/utils/GlobalPath.js'
import systemConfig from '@/utils/systemType.js'
import keywordsData from '@/utils/keyword.js'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/index.scss'
import '@/styles/content_style.css'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import titleMixin from '@/utils/headManage'
import { sync } from 'vuex-router-sync'
import '@/icons' // icon
// mixin for handling title
Vue.mixin(titleMixin)
Vue.use(ElementUI, { zhLocale })
Vue.prototype.serverUrl = serverUrl
Vue.prototype.keywordsData = keywordsData
Vue.prototype.systemConfig = systemConfig
Vue.prototype.setloca = function(key, val, expire) {
  var exp = expire ? Date.now() + expire * 1000 : -1
  localStorage.setItem(key, JSON.stringify({ value: val, expire: exp }))
}
Vue.prototype.getLoca = function(key) {
  var data = localStorage.getItem(key)
  if (!data) return null
  var dataObj = JSON.parse(data)
  if (dataObj.expire == -1) return dataObj.value
  if (Date.now() >= dataObj.expire) {
    localStorage.removeItem(key)
    return null
  } else {
    return dataObj.value
  }
}
export function createApp(context) {
  const router = createRouter()
  const store = createStore()
  sync(store, router)
  // /年月日时分秒
  Vue.filter('changeTime', function(val) {
    if (typeof (val) === 'string') {
      val = val.replace(/-/g, '/')
    }
    var date = new Date(val)
    var year = date.getFullYear()
    var month = date.getMonth() + 1
    var day = date.getDate()
    var hour = date.getHours()
    var minutes = date.getMinutes()
    if (minutes < 10) {
      minutes = '0' + minutes
    }
    if (hour < 10) {
      hour = '0' + hour
    }
    if (day < 10) {
      day = '0' + day
    }
    if (month < 10) {
      month = '0' + month
    }
    return `${year}-${month}-${day} ${hour}:${minutes}`
  })
  // 年月日
  Vue.filter('changeTime2', function(val) {
    if (typeof (val) === 'string') {
      val = val.replace(/-/g, '/')
    }
    var date = new Date(val)
    var year = date.getFullYear()
    var month = date.getMonth() + 1
    var day = date.getDate()
    if (day < 10) {
      day = '0' + day
    }
    if (month < 10) {
      month = '0' + month
    }
    return `${year}-${month}-${day}`
  })
  Vue.filter('changeTime3', function(val) {
    // if (typeof (val) === 'string') {
    //   val = val.replace(/-/g, '/')
    // }
    var date = new Date(val)
    var year = date.getFullYear()
    var month = date.getMonth() + 1
    var day = date.getDate()
    if (day < 10) {
      day = '0' + day
    }
    if (month < 10) {
      month = '0' + month
    }
    return `${year}年${month}月${day}日`
  })
  Vue.filter('changeTime4', function(val) {
    // if (typeof (val) === 'string') {
    //   val = val.replace(/-/g, '/')
    // }
    if (val) {
      var date = new Date(val.split(' ')[0])
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var day = date.getDate()
      if (day < 10) {
        day = '0' + day
      }
      if (month < 10) {
        month = '0' + month
      }
      return `${year}年${month}月${day}日` + ' ' + val.split(' ')[1]
    } else {
      return ''
    }
  })
  Vue.filter('changeType_album', function(value) {
    if (value == 'pengshichunqiu') {
      return '彭氏春秋'
    } else if (value == 'pengshishidian') {
      return '彭祖事典'
    } else if (value == 'pengshiqiye') {
      return '彭氏企业'
    } else if (value == 'pengshimingren') {
      return '彭氏名人'
    } else if (value == 'qita') {
      return '其他'
    }
  })
  // /转换undefind
  Vue.filter('changeUndefind', function(val) {
    if (val === 'undefined' && !val) {
      return ''
    } else {
      return val
    }
  })
  Vue.filter('changenum', function(val) {
    if (val >= 10000) {
      var newval = parseInt(val / 10000) + '万'
      return newval
    } else {
      return val
    }
  })
  Vue.filter('changestate', function(val) {
    var newval = ''
    if (val == 1) {
      newval = '已通过'
    } else if (val == 2) {
      newval = '待审核'
    } else if (val == 0) {
      newval = '未通过'
    }
    return newval
  })
  Vue.filter('changeSpeak', function(val) {
    if (typeof (val) === 'string') {
      val = val.replace(/-/g, '/')
    }
    const d = new Date(val)
    const now = Date.now()
    const diff = (now - d) / 1000

    if (diff < 30) {
      return '刚刚'
    } else if (diff < 3600) {
      // less 1 hour
      return Math.ceil(diff / 60) + '分钟前'
    } else if (diff < 3600 * 24) {
      return Math.ceil(diff / 3600) + '小时前'
    }
    if (diff >= 3600 * 24 && diff <= 3600 * 24 * 7) {
      return Math.floor(diff / 3600 / 24) + '天前'
    }
    if (diff > 3600 * 24 * 7) {
      var year = d.getFullYear()
      var month = d.getMonth() + 1
      var day = d.getDate()
      var hour = d.getHours()
      var minutes = d.getMinutes()
      if (minutes < 10) {
        minutes = '0' + minutes
      }
      if (hour < 10) {
        hour = '0' + hour
      }
      if (month < 10) {
        month = '0' + month
      }
      return `${year}-${month}-${day} ${hour}:${minutes}`
    }
  })
  // router.beforeEach((to, from, next) => {
  //   if (to.meta.requireAuth) {
  //     if (window.localStorage) {
  //       if (window.localStorage.getItem('userid')) {
  //         next()
  //       } else {
  //         next({
  //           path: '/login'
  //         })
  //       }
  //     } else {
  //       next()
  //     }
  //   } else {
  //     next()
  //   }
  // })
  const app = new Vue({
    router,
    store,
    render: h => h(App)
  })
  return { app, router, store }
}
